/*
 *
 * AttractionsPage reducer
 *
 */

import produce from 'immer';
import { ActionTypes } from './actions';

export const key = 'attractionsPage';
export const initialState = {
    featuredCategories: {
        categories: [],
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
    },
    is404: false,
    page: {
        activities: [],
        errorMessage: '',
        hasMore: false,
        isError: false,
        isLoaded: false,
        isLoading: false,
        page: 1,
        // seo-friendly-array-from-ssr
        preloaded: [],
        isPreloadedVisible: false,
        total: 0,
    },
    params: {
        category: '',
        destination: '',
    },
    query: {
        from: 0,
        to: 0,
    },
    recommends: {
        res: [],
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
    },
    userImages: {
        res: [],
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
    },
};

/* eslint-disable no-param-reassign, default-case */
function attractionsPageReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            // Common
            case ActionTypes.SET_PARAMS:
                draft.params = action.params;
                return draft;
            case ActionTypes.SET_QUERY:
                draft.query = action.query;
                return draft;
            case ActionTypes.SET_IS_404:
                draft.is404 = action.is404;
                return draft;
            // Page
            case ActionTypes.RESET_PAGE:
                draft.page.activities = [];
                return draft;
            case ActionTypes.FETCH_PAGE_STARTED:
                draft.page.isLoading = true;
                draft.page.isError = false;
                draft.page.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_PAGE_SUCCESSFULLY:
                draft.page.isLoading = false;
                draft.page.isLoaded = true;
                draft.page.activities = action.activities;
                return draft;
            case ActionTypes.FETCH_PAGE_FAILED:
                draft.page.isLoading = false;
                draft.page.isError = true;
                draft.page.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_PAGE_CANCELLED:
                draft.page.isLoading = false;
                return draft;
            case ActionTypes.SET_PAGE_IS_LOADED:
                draft.page.isLoaded = action.isLoaded;
                return draft;
            case ActionTypes.SET_PAGE_PAGE:
                draft.page.page = action.page;
                return draft;
            case ActionTypes.SET_PAGE_TOTAL:
                draft.page.total = action.total;
                return draft;
            case ActionTypes.SET_PAGE_HAS_MORE:
                draft.page.hasMore = action.hasMore;
                return draft;
            case ActionTypes.SET_PAGE_PRELOADED:
                draft.page.preloaded = action.preloaded;
                return draft;
            case ActionTypes.SET_PAGE_IS_PRELOADED_VISIBLE:
                draft.page.isPreloadedVisible = action.isPreloadedVisible;
                return draft;
            // Recommends
            case ActionTypes.RESET_RECOMMENDS:
                draft.recommends.res = [];
                return draft;
            case ActionTypes.FETCH_RECOMMENDS_STARTED:
                draft.recommends.isLoading = true;
                draft.recommends.isError = false;
                draft.recommends.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_RECOMMENDS_SUCCESSFULLY:
                draft.recommends.isLoading = false;
                draft.recommends.isLoaded = true;
                draft.recommends.res = action.res;
                return draft;
            case ActionTypes.FETCH_RECOMMENDS_FAILED:
                draft.recommends.isLoading = false;
                draft.recommends.isError = true;
                draft.recommends.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_RECOMMENDS_CANCELLED:
                draft.recommends.isLoading = false;
                return draft;
            case ActionTypes.SET_RECOMMENDS_IS_LOADED:
                draft.recommends.isLoaded = action.isLoaded;
                return draft;
            // FeaturedCategories
            case ActionTypes.RESET_FEATURED_CATEGORIES:
                draft.featuredCategories.categories = [];
                return draft;
            case ActionTypes.FETCH_FEATURED_CATEGORIES_STARTED:
                draft.featuredCategories.isLoading = true;
                draft.featuredCategories.isError = false;
                draft.featuredCategories.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_FEATURED_CATEGORIES_SUCCESSFULLY:
                draft.featuredCategories.isLoading = false;
                draft.featuredCategories.isLoaded = true;
                draft.featuredCategories.categories = action.categories;
                return draft;
            case ActionTypes.FETCH_FEATURED_CATEGORIES_FAILED:
                draft.featuredCategories.isLoading = false;
                draft.featuredCategories.isError = true;
                draft.featuredCategories.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_FEATURED_CATEGORIES_CANCELLED:
                draft.featuredCategories.isLoading = false;
                return draft;
            case ActionTypes.SET_FEATURED_CATEGORIES_IS_LOADED:
                draft.featuredCategories.isLoaded = action.isLoaded;
                return draft;
            // userImages
            case ActionTypes.FETCH_USER_IMAGES_STARTED:
                draft.userImages.isLoading = true;
                draft.userImages.isError = false;
                draft.userImages.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_USER_IMAGES_SUCCESSFULLY:
                draft.userImages.isLoading = false;
                draft.userImages.isLoaded = true;
                draft.userImages.res = { ...action.res, ...draft.userImages.res };
                return draft;
            case ActionTypes.FETCH_USER_IMAGES_FAILED:
                draft.userImages.isLoading = false;
                draft.userImages.isError = true;
                draft.userImages.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_USER_IMAGES_CANCELLED:
                draft.userImages.isLoading = false;
                return draft;
            case ActionTypes.SET_USER_IMAGES_IS_LOADED:
                draft.userImages.isLoaded = action.isLoaded;
                return draft;
            default:
                return draft;
        }
    });
}

export default attractionsPageReducer;
